import { ForbiddenComponent } from './-components/ErrorPages/Forbidden.tsx'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forbidden')({
  component: RouteComponent
})

function RouteComponent() {
  return <ForbiddenComponent />
}
